// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__HamkF","item":"PaymentsMobile_item__W2Hkk","label":"PaymentsMobile_label__6s6B9","amount":"PaymentsMobile_amount__3UngG"};